import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { Stack, AppBar, Box, Container, Typography, Toolbar, Button, Grid, Link } from '@mui/material';
import { Home } from '@mui/icons-material'

export default function Layout() {

    return (
        <React.Fragment>                                      
            <AppBar position='fixed'>    
                <Container>
                    <Toolbar>             
                        <Box sx={{ flexGrow: 1 }}>                    
                            <Link color='inherit' underline='none' href='/#home' sx={{ flexGrow: 1 }}>       
                                <Stack spacing={1} direction='row'>
                                    <Home sx={{ fontSize:28 }}/>                         
                                    <Typography variant='h6' >                         
                                        OK Engineering SA
                                    </Typography> 
                                </Stack>                              
                            </Link> 
                        </Box>                                                                     
                        
                        {/* <Button color="inherit" href='#about' sx={{ display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' } }}>Nosotros</Button> */}
                        <Button color="inherit" href='/#works' sx={{ display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' } }}>Trabajos</Button>
                        <Button color="inherit" href='/#services' sx={{ display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' } }}>Servicios</Button>
                        <Button color="inherit" href='/#location' sx={{ display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' } }}>Ubicación</Button> 
                        <Button color="inherit" href='/#contact' sx={{ display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' } }}>Contacto</Button>  
                        <Button color="inherit" href='downloads' sx={{ display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' } }}>Descargas</Button>                                                                  
                    </Toolbar> 
                </Container>                              
            </AppBar>  

            <Box>
                <Outlet />    
            </Box>                         
            
            <AppBar position='static' color='primary'>
                <Container sx={{ mt: 4, mb: 4 }}>
                    <Grid container>
                        <Grid size={6}>
                            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                <Typography variant="subtitle1">Copyright © OK Engineering S.A. {(new Date()).getFullYear()}</Typography>
                            </Box>                           
                        </Grid>
                        <Grid size={6} sx={{ textAlign:'right'}}>
                            <Link color='inherit' underline='none' href='https://maps.app.goo.gl/iLReoDhC7LZmTcst5' target='_blank'>
                                <Typography variant='subtitle1'>Ruta 70 Km 86, Rafaela 2300, Santa Fe, Argentina</Typography> 
                            </Link>  
                            {/* <Typography variant='subtitle1'>Email: ingenieria@okingenieria.com.ar</Typography>     */}
                            <Typography variant='subtitle1'>Tel: +541154680707</Typography>                            
                        </Grid>
                    </Grid>                                                                     
                </Container> 
            </AppBar>
        </React.Fragment>    
    )
}